export default __webpack_public_path__ + "static/media/plow-scarecrow.5703cb81.jpg";